module.exports = "/_next/static/images/Error@2x-fed5968fdecab1fac471000d1a501a5f.png";